import React from "react";

const HeaderIcon = (props: any) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 4.167A.833.833 0 0 0 4.167 5v1.667h11.666V5A.834.834 0 0 0 15 4.167H5ZM17.5 5A2.5 2.5 0 0 0 15 2.5H5A2.5 2.5 0 0 0 2.5 5v10A2.5 2.5 0 0 0 5 17.5h10a2.5 2.5 0 0 0 2.5-2.5V5Zm-1.667 3.333H4.167V15a.833.833 0 0 0 .833.833h10a.834.834 0 0 0 .833-.833V8.333Z"
			clipRule="evenodd"
		/>
	</svg>
);

const FooterIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 4.167A.833.833 0 0 0 4.167 5v6.667h11.666V5A.834.834 0 0 0 15 4.167H5ZM17.5 5A2.5 2.5 0 0 0 15 2.5H5A2.5 2.5 0 0 0 2.5 5v10A2.5 2.5 0 0 0 5 17.5h10a2.5 2.5 0 0 0 2.5-2.5V5Zm-1.667 8.333H4.167V15a.833.833 0 0 0 .833.833h10a.834.834 0 0 0 .833-.833v-1.667Z"
			clipRule="evenodd"
		/>
	</svg>
);

const PageIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			// eslint-disable-next-line
			d="M4.556 3.778a.778.778 0 0 0-.778.778V6.11h12.444V4.556a.778.778 0 0 0-.778-.778H4.555Zm13.222.778a2.333 2.333 0 0 0-2.334-2.334H4.555a2.333 2.333 0 0 0-2.333 2.334v10.888a2.333 2.333 0 0 0 2.334 2.334h10.888a2.333 2.333 0 0 0 2.334-2.334V4.555Zm-1.556 3.11H8.444v8.556h7c.43 0 .778-.348.778-.778V7.667ZM6.89 16.223V7.667H3.778v7.777c0 .43.348.778.778.778h2.333ZM10 10.468c0-.43.35-.778.779-.778h3.11a.778.778 0 1 1 0 1.555h-3.11a.778.778 0 0 1-.778-.777Zm0 3.266c0-.43.35-.777.779-.777h3.11a.778.778 0 1 1 0 1.555h-3.11a.778.778 0 0 1-.778-.778Z"
			clipRule="evenodd"
		/>
	</svg>
);

const PostIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 4.167A.833.833 0 0 0 4.167 5v10a.833.833 0 0 0 .833.833h1.667V4.167H5ZM5 2.5A2.5 2.5 0 0 0 2.5 5v10A2.5 2.5 0 0 0 5 17.5h10a2.5 2.5 0 0 0 2.5-2.5V5A2.5 2.5 0 0 0 15 2.5H5Zm3.333 1.667v11.666H15a.834.834 0 0 0 .833-.833V5A.834.834 0 0 0 15 4.167H8.333Z"
			clipRule="evenodd"
		/>
	</svg>
);

const ArchiveIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5 4.167A.833.833 0 0 0 4.167 5v10a.833.833 0 0 0 .833.833h10a.834.834 0 0 0 .833-.833V5A.834.834 0 0 0 15 4.167H5Zm-1.768-.935A2.5 2.5 0 0 1 5 2.5h10A2.5 2.5 0 0 1 17.5 5v10a2.5 2.5 0 0 1-2.5 2.5H5A2.5 2.5 0 0 1 2.5 15V5a2.5 2.5 0 0 1 .732-1.768Z"
			clipRule="evenodd"
		/>
		<path
			fillRule="evenodd"
			d="M6.104 6.105a.926.926 0 0 1 .655-.272H8.61a.926.926 0 0 1 .926.926v1.852a.926.926 0 0 1-.926.926H6.759a.926.926 0 0 1-.926-.926V6.76c0-.245.098-.48.271-.654Zm2.507.654H6.759v1.852H8.61V6.76Zm-2.778 4.63c0-.256.207-.463.463-.463h7.407a.463.463 0 0 1 0 .926H6.296a.463.463 0 0 1-.463-.463Zm0 2.315c0-.256.207-.463.463-.463h5.555a.463.463 0 0 1 0 .926H6.296a.463.463 0 0 1-.463-.463Z"
			clipRule="evenodd"
		/>
	</svg>
);

const NotFoundIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			// eslint-disable-next-line
			d="M2.5 5c.46 0 .834.373.834.833v3.334H5V5.833a.833.833 0 0 1 1.667 0v8.334a.833.833 0 0 1-1.667 0v-3.334H3.334a1.667 1.667 0 0 1-1.667-1.666V5.833c0-.46.373-.833.833-.833Zm5.488.488A1.667 1.667 0 0 1 9.167 5h1.667A1.667 1.667 0 0 1 12.5 6.667v6.666A1.667 1.667 0 0 1 10.834 15H9.167A1.667 1.667 0 0 1 7.5 13.333V6.667c0-.442.176-.866.488-1.179Zm2.846 1.179H9.167v6.666h1.667V6.667ZM14.167 5c.46 0 .833.373.833.833v3.334h1.667V5.833a.833.833 0 0 1 1.667 0v8.334a.833.833 0 0 1-1.667 0v-3.334H15a1.667 1.667 0 0 1-1.666-1.666V5.833c0-.46.373-.833.833-.833Z"
			clipRule="evenodd"
		/>
	</svg>
);

const SearchIcon = (props: any) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			d="M5.718 2.02a6.833 6.833 0 0 1 8.102 10.386l4.387 4.387a1 1 0 0 1-1.414 1.414l-4.387-4.387A6.831 6.831 0 0 1 2.02 10.948 6.833 6.833 0 0 1 5.718 2.02ZM8.333 3.5a4.833 4.833 0 1 0 0 9.666 4.833 4.833 0 0 0 0-9.666Z"
			clipRule="evenodd"
		/>
	</svg>
);

export const SIDEBAR_ITEMS = [
	{
		type: "header",
		label: "Header",
		icon: HeaderIcon,
	},
	{
		type: "footer",
		label: "Footer",
		icon: FooterIcon,
	},
	{
		type: "front",
		label: "Front Page",
		icon: PageIcon,
	},
	{
		type: "single",
		label: "Single Post",
		icon: PostIcon,
	},
	{
		type: "archive",
		label: "Archive",
		icon: ArchiveIcon,
	},
	{
		type: "404",
		label: "404 Page",
		icon: NotFoundIcon,
	},
	{
		type: "search",
		label: "Search Result",
		icon: SearchIcon,
	},
];
